import { useStore as getStore } from "../../utils/useStore.js";
import mailViewFactory from "./mailViewFactory.js";
const initialState = () => ({
  fetchedFilesList: [],
  filesList: [],
  fileSelection: [],
  filesSorting: null,
  foldersList: [],
  gridView: true,
  mobileGridView: false,
  gridRef: null,
  pageNumber: 1,
  audioPlaySrc: "",
});
const [MailViewProvider, useMailView, withMailView] = getStore(
  mailViewFactory,
  initialState,
  "MailView"
);
export const mailViewInitState = initialState();
export { useMailView, MailViewProvider, withMailView };
export default MailViewProvider;
